<template>
    <div class="wrapper">
        <div class="main-panel">
            <div class="main-content">
                <div class="content-wrapper">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-md-8 offset-md-2">
                                <div class="card">
                                    <div class="card-body">
                                        <div class="px-3">
                                            <h3>{{ $t("labels.newSuggestion") }}</h3>
                                            <p>
                                                {{ $t("labels.supportInstructions") }}
                                            </p>
                                            <form class="form">
                                                <div class="form-group">
                                                    <label for="suggestionBody">{{ $t("labels.subject") }}</label>
                                                    <input type="text" class="form-control" v-model="suggestion.title">
                                                </div>
                                                <div class="form-group">
                                                    <!--
                                                    <label for="suggestionType">{{ $t("labels.type") }}</label>
                                                    <select class="form-control" id="suggestionType" v-model="suggestion.type" >
                                                        <option value="issue">{{ $t("labels.issue") }}</option>
                                                        <option value="suggestion">{{ $t("labels.suggestion") }}</option>
                                                    </select>
                                                    -->
                                                    <input type="radio" id="issue" value="issue" v-model="suggestion.type">
                                                    <label for="issue">{{ $t("labels.issue") }}</label>
                                                    <br>
                                                    <input type="radio" id="suggestion" value="suggestion" v-model="suggestion.type">
                                                    <label for="suggestion">{{ $t("labels.suggestion") }}</label>
                                                </div>
                                                <div class="form-group">
                                                    <label for="suggestionBody">{{ $t("labels.suggestionBody") }}</label>
                                                    <textarea class="form-control" id="suggestionBody" v-model="suggestion.body"></textarea>
                                                </div>
                                                <div class="form-actions">
                                                    <button type="button" class="btn btn-success" @click.prevent="sendSuggestion">
                                                        <i class="icon-note"></i> {{ $t("labels.send") }}
                                                    </button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SuggestionService from '@/services/suggestions'

export default {
    data() {
        return {
            errors: [],
            suggestion: {
                title: '',
                type: '',
                body: ''
            }
        }
    },
    methods: {
        sendSuggestion: async function() {
            // Loading may be needed
            this.errors = []
            if (this.suggestion.title.length === 0) {
                this.errors.push(this.$t("errors.cantBeEmpty", [this.$t('labels.title')]))
            }
            if (this.suggestion.type.length === 0) {
                this.errors.push(this.$t("errors.cantBeEmpty", [this.$t('labels.type')]))
            }
            if (this.suggestion.body.length === 0) {
                this.errors.push(this.$t("errors.cantBeEmpty", [this.$t('labels.suggestionBody')]))
            }
            if (this.errors.length === 0) {
                let result = await SuggestionService.create(this.suggestion)
                if (result) {
                    this.$miniToastr.success(this.$t("flash.sendSuccess"))
                    this.suggestion = {
                        title: '',
                        type: '',
                        body: ''
                    }
                } else {
                    for (let error in result.data.errors) {
                        this.errors.push(result.data.errors[error].msg)
                    }
                    this.$miniToastr.error(this.errors.toString().split(",").join("<hr/>"))
                }
            } else {
                this.$miniToastr.error(this.errors.toString().split(",").join("<hr/>"))
            }
        }
    }
}
</script>

<style lang="scss">
    h3 {
        margin-top: 25px;
    }

    textarea {
        min-height: 150px;
    }
</style>


